var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgYoutubeSquare = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.173 8.353l4.675 2.657-4.675 2.657V8.353zM22 2.357v17.286A2.358 2.358 0 0119.643 22H2.357A2.358 2.358 0 010 19.643V2.357A2.358 2.358 0 012.357 0h17.286A2.358 2.358 0 0122 2.357zm-2.063 8.658s0-2.927-.373-4.332a2.24 2.24 0 00-1.581-1.59c-1.39-.38-6.983-.38-6.983-.38s-5.593 0-6.983.378a2.243 2.243 0 00-1.581 1.591c-.373 1.4-.373 4.332-.373 4.332s0 2.927.373 4.331a2.21 2.21 0 001.581 1.567c1.39.373 6.983.373 6.983.373s5.593 0 6.983-.378a2.21 2.21 0 001.581-1.567c.373-1.4.373-4.326.373-4.326z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYoutubeSquare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/youtube-square.07283c4a.svg";
export { ForwardRef as ReactComponent };